export default {
  current_action: "",
  has_giftwrap: false
}